import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as R from 'ramda'
import Section from 'components/Section'

import { doc, dirtyRead } from 'selectors/common'

import Employment from './Employment'

let select = (state, props) => ({
	application: doc(state, props.applicationID)
})

export class AdditionalResidents extends Component{
	render(){
		let { props } = this
		return(
			<div>
				{
					R.map(resident => {
						return (
							<Section
								id={`additionalResident${resident.firstName}${resident.lastName}`}
								title={`Additional resident: ${resident.firstName} ${resident.lastName}`}
							>
								<div className="additional-resident">
									<div className="age">
										<p>Age: {resident.age}</p>
									</div>
									<div className="relation">
										<p>Relation: {resident.relation}</p>
									</div>
									{resident.age.search("Child") == -1 &&
									<div>
										<div className="ssn">
											<p>SSN: {resident.ssn}</p>
										</div>
										<div className="dob">
											<p>DOB: {resident.dob}</p>
										</div>
										<div className="cell">
											<p>Cell: {resident.cell}</p>
										</div>
										<div className="email">
											<p>Email: {resident.email}</p>
										</div>
										 <Employment data={resident.employment} />
									</div>
									}
								</div>
							</Section>
					)})(props.application.additionalResidents)
				}
			</div>
		)
	}
}
export default connect(select)(AdditionalResidents)



// WEBPACK FOOTER //
// ./src/routes/manager/applicationForm/AdditionalResidents.js